// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"EZ-z","subtitle":"FZ-z","wrapper":"GZ-z","leftArrow":"HZ-z","rightArrow":"IZ-z"};